import React, { useEffect } from "react";
import Image2 from "./img_pro/webp/UNIK SYSTEM.webp";
import AOS from "aos";
import "aos/dist/aos.css";

/* ---------------------------------------
  Section3
---------------------------------------- */
const Section3 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="Section3">
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            {/* Image */}
            <div className="col-lg-6 about-image" data-aos="flip-left">
              <img
                className="sd-photo-box1"
                src={Image2}
                alt="img2"
                loading="lazy"
              />
            </div>

          
            {/* Texte */}
            <div className="col-lg-6">
              <h4 className="section-title mb-4" data-aos="fade-up">
                À propos de nous
              </h4>
              <h1 className="display-5" id="tit" data-aos="fade-up">
                L’expertise au service de vos espaces
              </h1><br />

              <p data-aos="fade-up">
                <b>UNIK SYSTEM®</b>, fondée en 2010, est spécialisée dans les solutions textiles innovantes pour l’architecture intérieure et extérieure.
              </p>
              <p data-aos="fade-up">
                <b>UNIK SYSTEM®</b>, propose une gamme complète de prestations :
              

              <p data-aos="fade-up">
                <b id="tit">•</b> Solutions plafonds et murs tendus

                <br /><b id="tit">•</b> Solutions lumineuses et rétro-éclairées

                <br /><b id="tit">•</b> Solutions traitement acoustique
                <br /><b id="tit">•</b> Solutions décoration et signalétique

                <br /><b id="tit">•</b> Solutions protection solaire

                <br /><b id="tit">•</b>  Solutions architecture textile
              </p></p>

              <p data-aos="fade-up">
                <b>Notre objectif :</b> améliorer le confort, le design et la performance des espaces résidentiels, commerciaux et publics.
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
